export const COMPANY_NAME = "Odenberg Technologies";
export const WEBSITE_NAME = "Kokteilibaar";
export const WEBSITE_SLOGAN = "Digimenüü ja AI-baarmen";
export const COPYRIGHT = "Autoriõigus © " + COMPANY_NAME;

export const TOOLBAR_TITLE = "Kokteilibaar";
export const TOOLBAR_DESCRIPTION = "Digimenüü ja AI-baarmen";

export const SIDEBAR_TITLE = "Navigeeri";
export const SIDEBAR_MENU = "Menüü";
export const SIDEBAR_MENU_TOOLTIP = "Sirvi välja valitud ja täieliku retseptikogu kokteile";
export const SIDEBAR_CHAT = "AI-baarmen";
export const SIDEBAR_CHAT_TOOLTIP = "Küsi AI-lt joogisoovitusi";
export const SIDEBAR_ADMIN = "Seaded";
export const SIDEBAR_ADMIN_TOOLTIP = "Administraatori jooksvad seaded";
export const SIDEBAR_LOGIN = "Logi sisse";
export const SIDEBAR_LOGIN_TOOLTIP = "Külalise või administraatori parooliga sisselogimine";
export const SIDEBAR_PREFS = "Eelistused";
export const SIDEBAR_PREFS_TOOLTIP = "Keele ja jookide eelistused";
export const SIDEBAR_FAVORITES = "Lemmikud";
export const SIDEBAR_FAVORITES_TOOLTIP = "Tärniga märgitud joogid, mida proovida";

export const BUTTON_SIGNIN = "Logi sisse";
export const BUTTON_SIGNOUT = "Logi välja";
export const BUTTON_CANCEL = "Tühista";
export const BUTTON_BACK = "Tagasi";
export const BUTTON_NEXT = "Edasi";

export const SNACKBAR_ERROR_SERVER = "Serveriga ei õnnestunud ühendust saada. Kas taustateenus töötab?";
export const SNACKBAR_ERROR_RESPONSE = "Midagi läks valesti.";
export const SNACKBAR_SUCCESS_LOGIN = "Sisselogimine õnnestus.";
export const SNACKBAR_SUCCESS_SETTINGS = "Seaded salvestatud.";
export const SNACKBAR_SESSION_EXPIRED = "Palun logi uuesti sisse.";

export const LOGIN_TITLE = "Sisesta parool";
export const LOGIN_GUEST = "Külaline";
export const LOGIN_ADMIN = "Administraator";
export const LOGIN_PASSWORD_LABEL = "Parool";
export const LOGIN_SUBMIT = "Jätka";

export const MENU_CURATED = "Tänane menüü";
export const MENU_FULL = "Täielik nimekiri";
export const MENU_FILTERS = "Filtrid";
export const MENU_SEARCH = "Otsi kokteile…";
export const MENU_READY = "Valmis tegemiseks";
export const MENU_SHOW_RATING = "Näita hinnanguid";
export const MENU_BASE = "Baasalkohol";
export const MENU_BASE_ANY = "Kõik";
export const MENU_INGREDIENTS = "Koostisosad";
export const MENU_RATING = "Hinnang";
export const MENU_EMPTY = "Ükski kokteil ei vasta filtritele.";
export const MENU_LOADING = "Menüü laadimine…";
export const MENU_ACCESS_REQUIRED_TITLE = "Vajalik on sisselogimine";
export const MENU_ACCESS_REQUIRED_BODY =
    "See kokteilimenüü on parooliga kaitstud. Logi sisse külalisena, et jooke sirvida ja baarmeniga vestelda.";
export const MENU_FORBIDDEN_TITLE = "Juurdepääs keelatud";
export const MENU_FORBIDDEN_BODY =
    "Sinu praeguse sisselogimisega menüüd avada ei saa. Logi uuesti sisse külalisena või palu peremehel avada avalik juurdepääs.";
export const MENU_UNAVAILABLE_TITLE = "Menüü ajutiselt pole saadaval";
export const MENU_UNAVAILABLE_BODY =
    "Retsepte baari tabelist praegu laadida ei õnnestunud. Proovi hetke pärast uuesti.";
export const MENU_LOAD_ERROR_TITLE = "Menüüd ei õnnestunud laadida";
export const MENU_LOAD_ERROR_BODY =
    "Menüü laadimisel tekkis viga. Kontrolli ühendust või proovi uuesti.";
export const MENU_RETRY = "Proovi uuesti";
export const MENU_GO_LOGIN = "Logi sisse";
export const MENU_ASK_BARTENDER = "Küsi baarmenilt";
export const MENU_FAVORITE = "Lisa lemmikutesse";
export const MENU_UNFAVORITE = "Eemalda lemmikutest";
export const MENU_SURPRISE_ME = "Üllata mind";
export const MENU_SURPRISE_EMPTY = "Tänase menüü valmis jookide seas pole sinu eelistustele vastavat.";
export const FAVORITES_TITLE = "Lemmikud";
export const FAVORITES_SUBTITLE = "Tärniga märgitud joogid.";
export const FAVORITES_EMPTY = "Lemmikuid pole veel. Märgi menüüs kokteil tärniga, et see siia salvestada.";
export const MENU_PAGE_SIZE = "Lehel";
export const MENU_PAGE_PREV = "Tagasi";
export const MENU_PAGE_NEXT = "Edasi";
export const menuPageOf = (page, pageCount) => `Leht ${page} / ${pageCount}`;
export const menuPageRange = (from, to, total) => `${from}–${to} / ${total}`;
export const MENU_CHIP_READY = "Valmis";
export const MENU_CHIP_ON_MENU = "Menüüs";
export const MENU_INSTRUCTIONS = "Juhised";
export const MENU_NOTES = "Märkused";
export const MENU_CLEAR_SEARCH = "Tühjenda otsing";
export const MENU_CLOSE = "Sulge";

export const CHAT_TITLE = "AI-baarmen";
export const CHAT_PLACEHOLDER = "Küsi soovitust…";
export const CHAT_SEND = "Saada";
export const CHAT_CLEAR = "Tühjenda vestlus";
export const CHAT_EDIT = "Muuda";
export const CHAT_RETRY = "Proovi uuesti";
export const CHAT_EDIT_HINT = "Muuda oma viimast sõnumit";
export const CHAT_RETRY_HINT = "Saada oma viimane sõnum uuesti";
export const CHAT_EMPTY =
    "Aitan sul leida õige joogi — kirjelda, mida soovid, ja soovitan midagi baari menüüst.";
export const CHAT_THINKING = "Mõtlen…";
/** Rotating status lines while waiting for the first stream token. */
export const CHAT_THINKING_LINES = [
    "Poleerin šeikerit…",
    "Konsulteerin jääga…",
    "Nuusutan tsitrust…",
    "Lehitsen retseptiraamatut…",
    "Kontrollin, mis laos olemas on…",
    "Segan valmis plaani…",
    "Pühin baariletti…",
    "Soojendan mõõtenõud…",
    "Küsin oliividelt teist arvamust…",
    "Loen üle bitteri tilgad…",
    "Jahutan coupe'i…",
    "Otsin õiget klaasi…",
    "Raputan välja halvad ideed…",
    "Pean läbirääkimisi mündiga…",
    "Otsin head kraami…",
    "Kalibreerin kallamist…",
    "Pühin tolmu retseptiraamatult…",
    "Mõtlen…"
];
export const chatDrinkPrompt = (drinkName) =>
    `Vaatasin menüüst jooki ${drinkName}. Räägi sellest — ajalugu, variatsioonid ja kas see sobiks minu jaoks.`;

/** Auto-sent when a guest leaves Welcome and opens the AI bartender. */
export const chatWelcomeRecommendPrompt = ({ drinkTypeLabel, tasteLabels }) => {
    return (
        `Valisin just oma eelistused. Soovita mulle menüüst mõnda jooki, mis sobiks. ` +
        `Eelista jooke, mis on täna valmis tegemiseks.`
    );
};

export const ADMIN_TITLE = "Administraatori seaded";
export const ADMIN_AUTH_ENABLED = "Nõua parooliga sisselogimist";
export const ADMIN_PUBLIC_ACCESS = "Ajutine avalik juurdepääs";
export const ADMIN_PUBLIC_HOURS = "Ava avalikult (tunde)";
export const ADMIN_PUBLIC_UNTIL = "Avalik juurdepääs kuni";
export const ADMIN_VENUE = "Vaikimisi asukoht";
export const ADMIN_VENUE_HELP =
    "Kasutatakse, kui külaline ei ole eelistustes asukohta valinud. Iga seade võib selle üle kirjutada.";
export const ADMIN_SAVE = "Salvesta seaded";
export const ADMIN_DENIED = "Vajalik on administraatori juurdepääs.";
export const ADMIN_IMAGES_TITLE = "Kokteilipildid";
export const ADMIN_IMAGES_HELP =
    "Laadi üles Google Sheetsi veebiekspordi (.zip). Parsime Recipes.html, seome jooginimed cellImage-failidega ja salvestame menüü jaoks vahemällu.";
export const ADMIN_IMAGES_UPLOAD = "Laadi Sheetsi ekspordi zip üles";
export const ADMIN_IMAGES_IMPORT_FOLDER = "Impordi serveri kaustast";
export const ADMIN_IMAGES_RESULT = "Impordi tulemus";
export const adminImagesImported = (imported, mapped) => `Imporditud ${imported}/${mapped} kokteilipilti`;
export const ADMIN_IMAGES_CACHED = "vahemälus";
export const ADMIN_MENU_TITLE = "Menüü andmed";
export const ADMIN_MENU_HELP =
    "Retseptid on Google Sheetsist vahemällu salvestatud. Värskenda pärast tabeli muutmist, et tuua uusimad andmed ilma vahemälu aegumist ootamata.";
export const ADMIN_MENU_REFRESH = "Värskenda Google Sheetsist";
export const ADMIN_MENU_EXPORT = "Kopeeri menüü eksport lõikelauale";
export const ADMIN_MENU_EXPORT_HELP =
    "Kopeerib ülal valitud vaikimisi asukoha jaoks kogu retseptiloendi ning millised koostisosad on laos või puudu — sobib teise chatboti jaoks.";
export const SNACKBAR_SUCCESS_MENU_REFRESH = "Menüü värskendatud Google Sheetsist.";
export const SNACKBAR_SUCCESS_MENU_EXPORT = "Menüü eksport kopeeritud lõikelauale.";
export const SNACKBAR_ERROR_MENU_EXPORT = "Menüü eksporti ei õnnestunud kopeerida.";

export const LANGUAGE_LABEL = "Keel";

export const PREFS_WELCOME_SUBTITLE = "Vali keel, asukoht ja milliseid jooke soovid sirvida.";
export const PREFS_EDIT_SUBTITLE = "Uuenda keele, jookide, maitse ja asukoha eelistusi.";
export const PREFS_LANGUAGE = "Keel";
export const PREFS_VENUE = "Asukoht";
export const PREFS_VENUE_HINT = "Millise kodubaari menüüd ja laoseisu kasutame?";
export const PREFS_DRINK_TYPE = "Mida soovid juua?";
export const PREFS_ALCOHOLIC = "Alkohoolsed kokteilid";
export const PREFS_NON_ALCOHOLIC = "Alkoholivabad kokteilid";
export const PREFS_TASTES = "Maitseeelistused";
export const PREFS_TASTES_HINT = "Valikuline — vali kõik sobivad. Baarmen arvestab nendega.";
export const PREFS_TASTE_BITTER = "Mõru";
export const PREFS_TASTE_TART = "Hapukas";
export const PREFS_TASTE_SWEET = "Magus";
export const PREFS_TASTE_FRUITY = "Puuviljane";
export const PREFS_TASTE_CITRUSY = "Tsitruseline";
export const PREFS_TASTE_HERBAL = "Taimne";
export const PREFS_TASTE_FLORAL = "Lilleline";
export const PREFS_TASTE_CREAMY = "Kreemjas";
export const PREFS_TASTE_NUTTY = "Pähkline";
export const PREFS_TASTE_SPICY = "Vürtsikas";
export const PREFS_TASTE_REFRESHING = "Värskendav";
export const PREFS_TASTE_BOOZY = "Kange";
export const PREFS_TASTE_LIGHT = "Kerge";
export const PREFS_TASTE_DRY = "Kuiv";
export const PREFS_TASTE_SMOKY = "Suitsune";
export const PREFS_TASTE_TROPICAL = "Troopiline";
export const PREFS_TASTE_BUBBLY = "Mulliline";
export const PREFS_CONTINUE = "Jätka menüü juurde";
export const PREFS_GO_MENU = "Sirvi menüüd";
export const PREFS_ASK_BARTENDER = "Küsi AI-baarmenilt";
export const PREFS_SAVE = "Salvesta eelistused";
export const MENU_DRINK_TYPE = "Joogid";
export const MENU_DRINK_TYPE_ALCOHOLIC = "Näidatakse alkohoolseid";
export const MENU_DRINK_TYPE_NON_ALCOHOLIC = "Näidatakse alkoholivabu";

export const MENU_TOUR_NEXT = "Edasi";
export const MENU_TOUR_DONE = "Selge";
export const MENU_TOUR_SKIP = "Sulge tuur";
export const MENU_TOUR_STEP = (current, total) => `${current} / ${total}`;
export const MENU_TOUR_VIEW_TITLE = "Tänane menüü vs täielik nimekiri";
export const MENU_TOUR_VIEW_BODY =
    "Tänane menüü näitab spetsiaalselt välja valitud jooke. Täielik nimekiri sisaldab kõiki retsepte.";
export const MENU_TOUR_SURPRISE_TITLE = "Üllata mind";
export const MENU_TOUR_SURPRISE_BODY =
    "Ei oska valida? See avab juhusliku valmis joogi tänasest menüüst.";
export const MENU_TOUR_FILTERS_TITLE = "Filtrid";
export const MENU_TOUR_FILTERS_BODY =
    "Ava filtrid otsimiseks, alkohoolsete / alkoholivabade vahetamiseks ning baasalkoholi, koostisosade ja valmisoleku järgi filtreerimiseks.";
export const MENU_TOUR_FAVORITE_TITLE = "Lemmikud";
export const MENU_TOUR_FAVORITE_BODY =
    "Puuduta joogi juures tähte, et see salvestada. Leiad nimekirja hiljem külgriba Lemmikute alt.";
export const MENU_TOUR_ASK_TITLE = "Küsi baarmenilt";
export const MENU_TOUR_ASK_BODY =
    "Puuduta säde-ikooni, et küsida AI-baarmenilt selle joogi kohta — ajalugu, variatsioonid ja kas see sobiks sulle.";
